const constants = {
  modal: {
    title: 'Sorry',
    text: 'The server is not available now, please try again later',
  },
};

export default constants;
